import React from 'react';
import { Stack, StackItem, IconButton } from 'office-ui-fabric-react';
import { DefaultButton } from '../Button/Default';
import { PrimaryButton } from '../Button/Primary';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const activeButtonStyles = {
  root: {
    margin: 3,
    width: 30,
    minWidth: 30,
    pointerEvents: 'none'
  }
};
const defaultButtonStyles = {
  root: {
    margin: 3,
    width: 30,
    minWidth: 30
  }
};
const paginationWrapperStackStyles = {
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row',
    alignItems: 'center',
    paddingTop: 10
  }
};
const paginationStackStyles = {
  root: {
    display: 'flex',
    alignItems: 'center'
  }
};
const paginationArrowsStyles = {
  root: {
    marginLeft: 3
  }
};
const getPaginationRange = (currentPage, totalPagesCount) => {
  const pageOffset = 2;
  let rangeStart = currentPage - pageOffset;
  if (rangeStart < 1) {
    rangeStart = 1;
  }
  let rangeEnd = rangeStart + pageOffset * 2;
  if (rangeEnd > totalPagesCount) {
    rangeEnd = totalPagesCount;
    rangeStart = rangeEnd - pageOffset * 2;
    if (rangeStart < 1) {
      rangeStart = 1;
    }
  }
  return {
    start: rangeStart,
    end: rangeEnd
  };
};
const getPaginationElements = (i, currentPage, onPageChange) => {
  const isActive = i === currentPage;
  if (isActive) {
    const ActiveElement = /*#__PURE__*/_jsx(PrimaryButton, {
      styles: activeButtonStyles,
      text: String(i),
      onClick: () => {
        onPageChange(i);
      }
    }, String(i));
    return ActiveElement;
  }
  const StandardElement = /*#__PURE__*/_jsx(DefaultButton, {
    styles: defaultButtonStyles,
    text: String(i),
    onClick: () => {
      onPageChange(i);
    }
  }, String(i));
  return StandardElement;
};
export const ListTablePagination = props => {
  const totalPagesCount = Math.ceil(props.totalItemsCount / props.pageSize);
  const range = getPaginationRange(props.currentPage, totalPagesCount);
  let paginationElements = [];
  for (let i = range.start; i <= range.end; i++) {
    paginationElements.push(getPaginationElements(i, props.currentPage, props.onPageChange));
  }
  const isNextButtonDisabled = props.currentPage >= totalPagesCount;
  const isPrevButtonDisabled = props.currentPage <= 1;
  const possiblyMaxItemsOnPageSum = props.currentPage * props.pageSize;
  const areEndPageItemsLess = possiblyMaxItemsOnPageSum > props.totalItemsCount;
  const showingInformation = "Showing ".concat((props.currentPage - 1) * props.pageSize + 1, " to ").concat(areEndPageItemsLess ? props.totalItemsCount : possiblyMaxItemsOnPageSum, " of ").concat(props.totalItemsCount, ".");
  if (!props.totalItemsCount) {
    return null;
  }
  const isBackToFirstPageVisible = props.currentPage !== 1;
  const isGoToLastPageVisible = props.currentPage !== totalPagesCount;
  return /*#__PURE__*/_jsxs(Stack, {
    styles: paginationWrapperStackStyles,
    children: [/*#__PURE__*/_jsx(StackItem, {
      children: showingInformation
    }), /*#__PURE__*/_jsxs(StackItem, {
      styles: paginationStackStyles,
      children: [isBackToFirstPageVisible && /*#__PURE__*/_jsx(StackItem, {
        children: /*#__PURE__*/_jsx(IconButton, {
          iconProps: {
            iconName: 'DoubleChevronLeft'
          },
          onClick: () => props.onPageChange(1),
          "data-id": 'first-page-button'
        })
      }), /*#__PURE__*/_jsx(IconButton, {
        "data-id": 'previous-button',
        iconProps: {
          iconName: 'ChevronLeft'
        },
        styles: {
          root: {
            marginRight: 3
          }
        },
        disabled: isPrevButtonDisabled,
        onClick: () => {
          props.onPageChange(props.currentPage - 1);
        }
      }), paginationElements, /*#__PURE__*/_jsx(IconButton, {
        "data-id": 'next-button',
        iconProps: {
          iconName: 'ChevronRight'
        },
        styles: paginationArrowsStyles,
        disabled: isNextButtonDisabled,
        onClick: () => {
          props.onPageChange(props.currentPage + 1);
        }
      }), isGoToLastPageVisible && /*#__PURE__*/_jsx(StackItem, {
        children: /*#__PURE__*/_jsx(IconButton, {
          iconProps: {
            iconName: 'DoubleChevronRight'
          },
          onClick: () => props.onPageChange(totalPagesCount),
          "data-id": "last-page-button"
        })
      })]
    })]
  });
};
ListTablePagination.defaultProps = {
  pageSize: 10
};